<template>
  <div class="page">
    <!-- your page -->
    <div class="pubHead">
      <Head></Head>
    </div>
    <div class="pay">
      <div class="fixation">
        <div class="method">
          <div class="Title">请选择支付方式</div>
          <div class="price">
            需支付: <span>{{ price }}</span> 元
          </div>
          <div class="line" v-for="item in method" :key="item.id">
            <div class="lineTitle">
              <div class="radioIn" @click="choose" :data-id="item.id">
                <img
                  src="../../assets/cart/duigou.png"
                  alt=""
                  v-show="item.select"
                  :data-id="item.id"
                />
              </div>
            </div>
            <div class="lineBox">
              <div class="lineIcon">
                <img
                  src="../../assets/cart/alipay.png"
                  alt=""
                  v-if="item.name == '支付宝支付'"
                />
                <img
                  src="../../assets/cart/wechat2.png"
                  alt=""
                  v-if="item.name == '微信支付'"
                />
                <img
                  src="../../assets/cart/residue.png"
                  alt=""
                  v-if="item.flag"
                />
              </div>
              {{ item.name }}
            </div>
          </div>
          <div class="enter">
            <div class="enterBtn" @click="enterPay">确认支付</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pubFoot">
      <Foot></Foot>
    </div>
    <div class="aliQuery" v-if="aliQuery">
      <div class="aliQueryBox">
        <div class="aliQueryTitle">请在新窗口之中完成支付</div>
        <div class="aliQueryBtn">
          <div class="aliQueryButton" @click="finshAlipay">支付完成</div>
        </div>
      </div>
    </div>
    <div class="wechatQuery" v-if="wechatQuery">
      <div class="wechatBox">
        <div class="wechatQRcode" v-html="payQRcode"></div>
        <div class="wechatHint">请扫码完成支付，支付完成后请点击确认</div>
        <div class="wechatBtn">
          <div class="wechatButton" @click="finshWechatPay">支付完成</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// your script
import Head from "../../components/head.vue";
import Foot from "../../components/foot.vue";
export default {
  name: "pay",
  components: {
    Head,
    Foot,
  },
  data() {
    return {
      clientHeight: 0,
      price: 0.0,
      method: [
        {
          id: "1",
          name: "支付宝支付",
          icon: require("../../assets/cart/alipay.png"),
          select: true,
        },
        {
          id: "2",
          name: "微信支付",
          icon: require("../../assets/cart/wechat2.png"),
          select: false,
        },
        {
          id: "3",
          name: "余额支付",
          icon: require("../../assets/cart/residue.png"),
          select: false,
        },
      ],
      aliQuery: false,
      payQRcode: "",
      wechatQuery: false,
    };
  },
  methods: {
    payList() {
      var data = {
        token: localStorage.getItem("token"),
        method: "payments.getlist",
      };
      console.log(data, "data");
      this.request(data, (res) => {
        for (let index in res.data) {
          res.data[index].id = index;
          res.data[index].select = false;
          // if(res.data[index].name=='支付宝支付'){
          // 	res.data[index].icon = '../../assets/cart/alipay.png'
          // }else if(res.data[index].name=='微信支付'){
          // 	res.data[index].icon = '../../assets/cart/wechat2.png'
          // }else if(res.data[index].name=='线下支付'|| res.data[index].name=='余额支付' || res.data[index].name=='积分支付'){
          // 	res.data[index].icon = '../../assets/cart/residue.png'
          // }
          if (
            res.data[index].name == "线下支付" ||
            res.data[index].name == "余额支付" ||
            res.data[index].name == "积分支付"
          ) {
            res.data[index].flag = true;
          }
        }
        this.method = res.data;
        console.log(this.method, "method");
      });
    },
    choose(e) {
      var id = e.target.dataset.id;
      var method = this.method;
      for (var i = 0; i < method.length; i++) {
        var mid = method[i].id;
        method[i].select = false;
        if (id == mid) {
          method[i].select = true;
        }
      }
    },
    enterPay() {
      var mode = this.type;
      var method = this.method;
      var type = "";
      for (var i = 0; i < method.length; i++) {
        var bool = method[i].select;
        if (bool) {
          type = method[i].name;
        }
      }
      var that = this;
      if (mode == "commodity") {
        if (type == "支付宝支付") {
          this.aliQuery = true;
          var data = {
            ids: this.order_id,
            payment_code: "alipay",
            payment_type: 1,
            token: this.token,
            method: "user.pay",
            "params[trade_type]": "PC",
            "params[wap_url]": "",
            "params[wap_name]": "我的网站",
          };
          if (this.from == "score") {
            data["is_integral"] = 1;
          }
          var str = "";
          for (let i in data) {
            str += i + "=" + data[i] + "&";
          }
          var url = this.requestUrl;
          window.open(url + "?" + str);
        } else if (type == "微信支付") {
          var data = {
            ids: this.order_id,
            payment_code: "wechatpay",
            payment_type: 1,
            token: this.token,
            method: "user.pay",
            "params[trade_type]": "NATIVE",
            "params[wap_url]": "http://localhost:8080",
            "params[wap_name]": "我的网站",
          };
          if (this.from == "score") {
            data["is_integral"] = 1;
          }
          var that = this;
          this.request(data, function (res) {
            if (res.status) {
              that.payQRcode = res.data;
              that.wechatQuery = true;
            } else {
              that.globalTest("user.pay", "error", res.msg, res.data);
            }
          });
        } else if (type == "余额支付") {
          var data = {
            ids: this.order_id,
            payment_code: "balancepay",
            payment_type: 1,
            token: this.token,
            method: "user.pay",
          };
          if (this.from == "score") {
            data["is_integral"] = 1;
          }
          this.request(data, function (res) {
            if (res.status) {
              that.$router.push({ path: "/success", query: {} });
            } else {
              that.globalTest("user.pay", "error", res.msg, res.data);
            }
          });
        } else {
          this.$alert("请联系客服进行线下支付", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
            },
          });
        }
      } else if (mode == "score") {
        //积分支付的方法
      }
    },
    finshAlipay() {
      this.queryOrderStatus("ali");
    },
    finshWechatPay() {
      this.queryOrderStatus("wechat");
    },
    queryOrderStatus(type) {
      var mode = this.type;
      var abc, order_id;
      mode == "commodity"
        ? ((abc = 0), (order_id = this.order_id))
        : ((abc = 1), (order_id = this.fid));
      var data = {
        order_id: order_id,
        token: this.token,
        method: "user.paystatus",
        type: abc,
      };
      var that = this;
      this.request(data, function (res) {
        if (res.pay_status == 2) {
          that.globalTest("user.paystatus", "success", "支付成功");
          if (mode == "commodity") {
            that.$router.push({ path: "/success", query: {} });
          }
        } else {
          var msg = res.msg;
          that.globalTest(
            "user.paystatus",
            "error",
            "获取支付状态失败，请尝试联系客服或重新支付"
          );
        }
        if (type == "ali") {
          that.aliQuery = false;
        } else {
          that.wechatQuery = false;
        }
      });
    },
  },
  beforeCreate: function () {
    //生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
  },
  created: function () {
    //生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
  },
  beforeMount: function () {
    //模板编译/挂载之前
  },
  mounted: function () {
    //模板编译/挂载之后
    this.payList();
    var type = this.$route.query.type;
    console.log(type, "mounted_type");
    this.type = type;
    var order_id = this.$route.query.order_id;
    this.order_id = order_id;
    var fid = this.$route.query.oid;
    this.fid = fid;
    var money = this.$route.query.free;
    this.price = money;
    var cid = this.$route.query.cid;
    this.cid = cid;
    var token = localStorage.getItem("token");
    this.token = token;
    this.clientHeight = `${document.documentElement.clientHeight - 503}`;
  },
  beforeUpdate: function () {
    //组件更新之前
  },
  updated: function () {
    //组件更新之后
  },
  activated: function () {
    // for keep-alive，组件被激活时调用
  },
  deactivated: function () {
    // for keep-alive，组件被移除时调用
  },
  beforeDestory: function () {
    // 组件销毁调用
  },
  destoryed: function () {
    // 组件销毁后调用
  },
};
</script>

<style scoped>
/* your css */
.pubHead,
.pubFoot {
  width: 100%;
  position: fixed;
  left: 0px;
  z-index: 10;
}
.pubHead {
  top: 0px;
  background: #ffffff;
}
.pubFoot {
  bottom: 0px;
}
.pay {
  width: 100%;
  height: 100%;
  padding-top: 160px;
  padding-bottom: 300px;
  background: #f0f0f0;
  box-sizing: border-box;
  position: fixed;
  z-index: 9;
}
.fixation {
  height: 100%;
  background: #ffffff;
}
.method {
  width: 100%;
}
.Title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px dashed #b3b3b3;
  padding: 0px 10px;
  box-sizing: border-box;
}
.price {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0px 10px;
  box-sizing: border-box;
  font-size: 16px;
}
.price span {
  color: red;
}
.line {
  width: 100%;
  height: 60px;
  position: relative;
  line-height: 60px;
  padding: 0px 10px;
  box-sizing: border-box;
}
.line .lineTitle {
  width: 50px;
  height: 100%;
  position: absolute;
  left: 10px;
  top: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lineTitle .radioIn {
  width: 20px;
  height: 20px;
  border: 1px solid #b3b3b3;
  border-radius: 50%;
}
.radioIn:hover {
  cursor: pointer;
}
.lineTitle .radioIn img {
  width: 100%;
  height: 100%;
  display: block;
}
.lineBox {
  width: 100%;
  height: 100%;
  padding-left: 50px;
  box-sizing: border-box;
}
.lineIcon {
  width: 50px;
  height: 100%;
  float: left;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lineIcon img {
  width: 30px;
  height: 30px;
  display: block;
}
.enter {
  width: 100%;
  height: 50px;
  padding: 0px 10px;
  box-sizing: border-box;
}
.enterBtn {
  width: 150px;
  height: 40px;
  border: 2px solid #333333;
  text-align: center;
  line-height: 36px;
  font-size: 16px;
  box-sizing: border-box;
}
.enterBtn:hover {
  background: #333333;
  color: #ffffff;
  cursor: pointer;
}
.aliQuery {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(255, 255, 255, 0.5);
  z-index: 99;
}
.aliQueryBox {
  width: 500px;
  height: 150px;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -250px;
  margin-top: -75px;
  border: 1px solid #b3b3b3;
  box-sizing: border-box;
}
.aliQueryTitle {
  width: 100%;
  height: 75px;
  line-height: 75px;
  text-align: center;
  font-size: 18px;
}
.aliQueryBtn {
  width: 100%;
  height: 50px;
  padding-top: 10px;
  box-sizing: border-box;
}
.aliQueryButton {
  width: 150px;
  height: 40px;
  background: #333333;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin: 0 auto;
}
.wechatQuery {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0px;
  top: 0px;
  background: rgba(255, 255, 255, 0.7);
  z-index: 99;
}
.wechatBox {
  width: 300px;
  height: 400px;
  border: 1px solid #b3b3b3;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -150px;
  margin-top: -200px;
}
.wechatQRcode {
  width: 280px;
  height: 280px;
  margin: 9px;
  background: #009688;
}
.wechatQRcode img {
  width: 100%;
  height: 100%;
}
.wechatHint {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
}
.wechatButton {
  width: 130px;
  height: 40px;
  text-align: center;
  margin: 0 auto;
  background: #333333;
  color: #ffffff;
  line-height: 40px;
}
</style>
